module.exports = __webpack_public_path__ + "img/logo_mdxl.ccaa780a.png";